export const LADE_PROGRAMM = "ladeProgramm"
export const STARTEN = "starten"
